<template>
  <div>
    <el-form ref="formRef" :model="form" label-suffix=":" label-width="100px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="项目名称" prop="projectName">
             <el-input disabled v-model="form.projectName"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="工单编号" prop="code">
            <el-input disabled v-model="form.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工单类型" prop="$moduleType">
            <el-input v-model="form.$moduleType" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="需求区域" prop="deptName">
            <el-input disabled v-model="form.areaName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="完成时间" prop="inspectType">
            <el-date-picker
              disabled
              style="width:100%"
              v-model="form.endTime"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="需求人" prop="inspectType">
               <el-input disabled v-model="form.requireManName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="deptName">
            <el-input disabled v-model="form.requireManPhone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="回访日期" prop="deptName">
            <el-date-picker
              disabled
              style="width:100%"
              v-model="form.returnVisitTime"
              type="date"
              placeholder="选择日期时间"
              align="right"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="回访人" prop="deptName">
            <el-input disabled v-model="form.returnVisitManName	"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="回访形式" prop="deptName">
            <el-input disabled v-model="form.wayDesc"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="满意度" prop="deptName">
            <!-- <el-input disabled v-model="form.$satisfaction"></el-input> -->
            <el-select
                  disabled
                  v-model="form.satisfaction"
                  style="width:100%"
                  placeholder="满意度"
                  clearable
                >
                  <el-option
                    v-for="item in satisfactionList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="服务标签" prop="deptName">
            <!-- <el-input disabled v-model="form.targets"></el-input> -->
             <el-select v-model="form.targets" disabled multiple placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in targetList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-for="(item,index) in form.detailList" :key="index">
          <el-form-item :label="item.targetName" prop="deptName">
            <el-rate
              v-model="item.level"
              disabled
            
              text-color="#ff9900"
              score-template="{value}"
            >
            </el-rate>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="服务质量" prop="deptName">
            <el-rate
              v-model="form.serveQuality"
              disabled
            
              text-color="#ff9900"
              score-template="{value}"
            >
            </el-rate>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="响应速度" prop="deptName">
            <el-rate
              v-model="form.serveSpeed"
              disabled
             
              text-color="#ff9900"
              score-template="{value}"
            >
            </el-rate>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="回访内容" prop="description">
            <el-input
              disabled
              type="textarea"
              v-model="form.content"
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {returnVisitedRecord} from '@/api/crmedical/order/orderreturnvisitrecord';
import remarkModel from "./actionForm/remark-model";
import {getDictionary,getBisDictData} from "@/api/common.js";
export default {
  props:['row'],
  components:{remarkModel},
  data() {
    return {
      form:{},
      targetList:[],
      satisfactionList:[]
    };
  },
 async created(){
   this.getSatisfactionList()
   getBisDictData({
     projectId:this.row.projectId,
     code:'project_order_service_target'
   }).then(res=>{
     this.targetList = res.data
   })
  await  this.getRecord()
    console.log("回访详情",this.row)
  },
  methods:{
    async getRecord(){
     await returnVisitedRecord({
        id:this.row.id
      }).then(res=>{
        console.log("接口")
        this.form = res.data
        this.form.satisfaction =  this.form.satisfaction +''
        this.form.$moduleType = this.row.$moduleType
        this.form.projectName = this.row.projectName
        // this.form.serveStatus = res.data.detailList[0].level
        // this.form.serveQuality = res.data.detailList[1].level
        // this.form.serveSpeed = res.data.detailList[2].level
        this.form.targets = this.form.targets.split(',')
      })
    },
    getSatisfactionList(){
      getDictionary('return_visit_satisfaction').then(res=>{
        this.satisfactionList = res.data
      })
    },
  }
};
</script>
<style scoped>
  ::v-deep .el-rate {
        margin-top: 6px;
  }
</style>
